import React from 'react';

import ClassicBlotterTab from './BlotterTab';
import BlotterTabV5 from './BlotterTabV5';
import { isV5MarketsExperience } from './MarketsTabV5/route';

type Props = {
  whichMarkets?: number | null;
};

const BlotterTabRoute: React.FC<Props> = ({ whichMarkets }) =>
  isV5MarketsExperience(whichMarkets) ? (
    <BlotterTabV5 />
  ) : (
    <ClassicBlotterTab />
  );

export default BlotterTabRoute;
